import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const NAV = [
  { href: '/demos', label: 'Demos', isRoute: true },
  { href: '#services', label: 'Services' },
  { href: '#process', label: 'Process' },
  { href: '#contact', label: 'Contact' },
];

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkHref = (item) => {
    if (item.isRoute) return item.href;
    return onHome ? item.href : `/${item.href}`;
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'glass shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center gap-2 group">
          <span className="w-8 h-8 rounded-lg bg-gradient-brand flex items-center justify-center font-display font-bold text-white shadow-glow">
            S
          </span>
          <span className="font-display font-bold text-lg tracking-tight text-text">
            Sudco<span className="gradient-text">.</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((item) => {
            const href = linkHref(item);
            return item.isRoute ? (
              <Link
                key={item.href}
                to={href}
                className="text-sm text-text-muted hover:text-text transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={item.href}
                href={href}
                className="text-sm text-text-muted hover:text-text transition-colors"
              >
                {item.label}
              </a>
            );
          })}
          <a
            href={onHome ? '#contact' : '/#contact'}
            className="text-sm bg-gradient-brand text-white px-5 py-2 rounded-full font-medium hover:shadow-glow transition-shadow"
          >
            Get a free demo
          </a>
        </nav>

        <button
          className="md:hidden text-text"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden glass-blur border-t border-border">
          <nav className="px-6 py-4 flex flex-col gap-4">
            {NAV.map((item) => {
              const href = linkHref(item);
              return item.isRoute ? (
                <Link
                  key={item.href}
                  to={href}
                  onClick={() => setOpen(false)}
                  className="text-text-muted hover:text-text"
                >
                  {item.label}
                </Link>
              ) : (
                <a
                  key={item.href}
                  href={href}
                  onClick={() => setOpen(false)}
                  className="text-text-muted hover:text-text"
                >
                  {item.label}
                </a>
              );
            })}
            <a
              href={onHome ? '#contact' : '/#contact'}
              onClick={() => setOpen(false)}
              className="bg-gradient-brand text-white px-5 py-2 rounded-full font-medium text-center"
            >
              Get a free demo
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}

export default Header;
